<p *ngIf="header == 'fileName' || header === 'certificationName'" class="mb-0 font-14 text-truncate  {{header === 'certificationName'? '':''}}">{{params.value}}</p>
<p *ngIf="header == 'expirationDate'" class="mb-0 font-14">{{dateRendererValue}}</p>

<div class="certification-tab">
  <div class="d-flex align-items-center">
    <div *ngIf="cellRendererParams?.download == 'download'" 
    [ngClass]="{'not-allowed': params.data.guId === '', 'hand': params.data.guId !== ''}"
    (click)="params.data.guId === '' ? null : download()">
    <img src="./assets/SVGIcons/grayDownload.svg" alt="">
    <span class="m-l-10">Download</span>
  </div>
  </div>
  <div class="d-flex align-items-center">
    <div *ngIf="cellRendererParams?.preview == 'preview'"
    [ngClass]="{'not-allowed': params.data.guId === '', 'hand': params.data.guId !== ''}"
    (click)="params.data.guId === '' ? null : change()">
    <img src="./assets/SVGIcons/grayPreview.svg" alt="">
    <span class="m-l-10">Preview</span>
  </div>
  </div>
  <div class="d-flex align-items-center " *ngIf="cellRendererParams?.edit"  (click)="edit()">
    <div class="hand">
      <img src="./assets/SVGIcons/edit.svg" alt="">
      <span class="m-l-10 hand">Edit</span>
    </div>
  </div>
  <div class="d-flex align-items-center"  *ngIf="cellRendererParams?.delete"  (click)="delete()">
    <div class="hand">
      <img src="./assets/SVGIcons/delete (1).svg" alt="">
      <span class="m-l-10">Delete</span>
    </div>
  </div>
</div>

<div *ngIf="header == 'categoryName'">
  <button class="button px-4-5">{{params.value}}</button>
</div>

<!-- for code-crosswalk page -->
  <div class="hand" *ngIf="header == 'editCodeCrosswalk'">
    <!-- <app-svg-icon
    (click)="editCodeCrosswalk()"
    class="py-2"
    [src]="'./assets/SVGIcons/edit.svg'"></app-svg-icon> -->
<img src="./assets/SVGIcons/edit.svg" alt="" class="py-2" (click)="editCodeCrosswalk()">
  </div>

  <div *ngIf="header == 'deleteCodeCrosswalk'"  >
    <img class="hand" src="./assets/SVGIcons/delete (1).svg" alt="" (click)="deleteRow(params)">
  </div>
<!-- for code-crosswalk page  -->

<div *ngIf="header == 'isExpired' && params.value !== ''" >
  <button class="button">{{params.value}}</button>
</div>
<!-- import-companies page -->
<div  *ngIf="header == 'status'">
  <!-- <app-svg-icon *ngIf="selectedDropdownValues"
  class="ps-3 mt-3 pe-none"
  [src]="'../../../../assets/SVGIcons/check-mark (1).svg'"
  ></app-svg-icon> -->
  <app-svg *ngIf="selectedDropdownValues"
  class="ps-3 mt-3 pe-none"
  iconType="CheckMark">                        
  </app-svg>
  <!-- <app-svg-icon *ngIf="!selectedDropdownValues"
  class="ps-3 mt-3 pe-none"
  [src]="'../../../../assets/SVGIcons/Group 41672.svg'"
  ></app-svg-icon> -->

  <app-svg *ngIf="!selectedDropdownValues" 
  class="ps-3 mt-3 pe-none"
  iconType="Group">                        
  </app-svg>
</div>


<div *ngIf="header == 'svgSuccess' && params.data.isValid==true" class="svg-success-container">
  <!-- <app-svg-icon
  class="ps-3 mt-2"
  [src]="'../../../../assets/SVGIcons/check-mark (1).svg'"
  ></app-svg-icon> -->
  <app-svg iconType="CheckMark" class="ps-3 mt-2">                        
  </app-svg>
</div>
<!-- import-companies page -->
<div *ngIf="params.colDef.field === 'fullName'">
  <span class="hand" (click)="openContactInfo(params)">{{params.value}}</span>
</div>
<div class="d-flex gap-3" *ngIf="params.splitLine">
  <span *ngIf="!params?.hideIcon" [ngClass]="{'invisible':!params?.data?.isDisable && params?.data?.isNewRow}"
   class="{{params?.data?.qty?'text-semi-primary':'text-light-info'}} font-14 hand" (click)="insertRow(params)">Split Line</span>
  <div [ngClass]="{'d-none':params?.data?.isDisable}"  class="">
    <span class="text-light-info font-11 s_n"
    [ngClass]="{
      'cursor-not-allowed': params?.data?.partConsignmentId && params?.data?.serialNumberModel?.length === 0 && !params?.data?.partInventoryId|| 
      params?.data?.partInventoryId && params?.data?.serialNumberModel?.length === 0 && !params?.data?.partConsignmentId,
      'hand': !(
      (params?.data?.partConsignmentId && params?.data?.serialNumberModel?.length === 0 && !params?.data?.partInventoryId) ||
      (params?.data?.partInventoryId && params?.data?.serialNumberModel?.length === 0 && !params?.data?.partConsignmentId)
    )
    }"
     (click)="onSerialNumber(params)">S/N</span>
  </div>
  <div [ngClass]="{'d-none':params?.data?.isDisable}" class="d-flex align-items-center">
  <svg (click)="insertImages(params)" id="Group_42699" data-name="Group 42699" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
    <g id="image_1_" data-name="image (1)">
      <g id="Group_42701" data-name="Group 42701">
        <g id="Group_42700" data-name="Group 42700">
          <path id="Path_1574" data-name="Path 1574" d="M17.444,0H2.556A2.559,2.559,0,0,0,0,2.556V17.444A2.559,2.559,0,0,0,2.556,20H17.444A2.559,2.559,0,0,0,20,17.444V2.556A2.559,2.559,0,0,0,17.444,0Zm1.378,17.444a1.379,1.379,0,0,1-1.378,1.378H2.556a1.379,1.379,0,0,1-1.378-1.378V15.3L5.055,12a.381.381,0,0,1,.491,0l2.429,2.017a.589.589,0,0,0,.793-.037l5.771-5.779a.381.381,0,0,1,.566.029L18.822,12.8v4.643Zm0-6.512-2.8-3.452A1.559,1.559,0,0,0,13.7,7.362l-5.391,5.4L6.3,11.088a1.557,1.557,0,0,0-2.007.012L1.178,13.749V2.556A1.379,1.379,0,0,1,2.556,1.178H17.444a1.379,1.379,0,0,1,1.378,1.378Z" fill="#8b9daa"/>
        </g>
      </g>
    </g>
  </svg>
</div> 
  <img *ngIf="!params?.hideIcon" 
 class="hand"
   src="./assets/SVGIcons/delete (1).svg" alt="" (click)="deleteRow(params)">
</div>
<div *ngIf="params?.splitDateCode">
  <span class="text-primary-color font-13 {{params?.data?.isSplitLine?'visible':'invisible'}}">Split</span>
  <span class="ps-2">{{(params.data?.dateCodeYearName && params.data?.dateCodeWeekName) ? (params.data?.dateCodeYearName + ' ' + params.data?.dateCodeWeekName) : '—'}} </span>
</div>
<div class="d-flex align-items-center position-relative"*ngIf="params?.colorCode">
      <i class="fa fa-circle pe-2"  
      [style.color]="color" style="font-size: x-small; margin-left: .5em;"></i>
      <span class="text-info-color hand"
            [ngbTooltip]="tooltipContent" 
            placement="bottom" 
            container="body"
            tooltipClass="custom-tooltip" 
            triggers="hover">
        {{inputValue}}
      </span>
</div>